import { render } from "./testimonyPage.vue?vue&type=template&id=8cb56546&scoped=true"
import script from "./testimonyPage.vue?vue&type=script&lang=js"
export * from "./testimonyPage.vue?vue&type=script&lang=js"

import "./testimonyPage.vue?vue&type=style&index=0&id=8cb56546&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb56546"]])

export default __exports__